// extracted by mini-css-extract-plugin
export default {"title":"MovingHomePaymentSection_title__CAOQx","amount":"MovingHomePaymentSection_amount__0xYtE","button":"MovingHomePaymentSection_button__1E--E"};